const API_BASE_URL = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') ?? ''
const FUNCTIONS_BASE = `${API_BASE_URL}/.netlify/functions`

const request = async (path, options = {}) => {
  const url = path.startsWith('http') ? path : `${FUNCTIONS_BASE}${path}`
  const { token, headers: optionHeaders = {}, ...rest } = options
  const headers = { 'Content-Type': 'application/json', ...optionHeaders }
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }
  const response = await fetch(url, {
    headers,
    ...rest,
  })

  if (!response.ok) {
    const message = await response.text()
    const err = new Error(message || `Request failed (${response.status})`)
    err.status = response.status
    throw err
  }

  const payload = await response.json().catch(() => ({}))
  return payload.data ?? payload
}

export const submitInquiry = (data, options = {}) =>
  request('/inquiries', {
    method: 'POST',
    body: JSON.stringify(data),
    token: options.token,
  })

export const submitOffer = (data, options = {}) =>
  request('/offers', {
    method: 'POST',
    body: JSON.stringify(data),
    token: options.token,
  })

const buildQuery = (params = {}) => {
  const search = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      search.set(key, value)
    }
  })
  const query = search.toString()
  return query ? `?${query}` : ''
}

export const fetchInquiries = (options = {}) => {
  const { token, ...query } = options
  return request(`/inquiries${buildQuery(query)}`, { token })
}

export const fetchOffers = (options = {}) => {
  const { token, ...query } = options
  return request(`/offers${buildQuery(query)}`, { token })
}

export const fetchBuyerOffers = ({ token } = {}) => request('/offers', { token })

export const respondToOffer = (data, options = {}) =>
  request('/offers', {
    method: 'PATCH',
    body: JSON.stringify(data),
    token: options.token,
  })

export const updateViewingRequest = (data, options = {}) =>
  request('/inquiries', {
    method: 'PATCH',
    body: JSON.stringify(data),
    token: options.token,
  })

export const fetchMessages = (options = {}) => {
  const { propertyId, scope, token } = options || {}
  const search = new URLSearchParams()
  if (propertyId) search.set('propertyId', propertyId)
  if (scope) search.set('scope', scope)
  const query = search.toString()
  return request(`/messages${query ? `?${query}` : ''}`, token ? { token } : {})
}

export const sendMessage = (data, options = {}) =>
  request('/messages', {
    method: 'POST',
    body: JSON.stringify(data),
    token: options.token,
  })

export const fetchDeals = (options = {}) => {
  const { token, ...query } = options
  return request(`/deals${buildQuery(query)}`, { token })
}

export const updateDealConveyancer = (data, options = {}) =>
  request('/deals', {
    method: 'POST',
    body: JSON.stringify(data),
    token: options.token,
  })

export const fetchConveyancers = (options = {}) => {
  const { token, ...query } = options
  return request(`/conveyancers${buildQuery(query)}`, { token })
}

export const recordServiceLead = (data, options = {}) =>
  request('/service-lead', {
    method: 'POST',
    body: JSON.stringify(data),
    token: options.token,
  })
